import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      paddingTop: "2rem"
    },
    stepContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      paddingLeft: "2rem",
      paddingRight: "2rem",
      flex: "1 1 auto",
      [theme.breakpoints.up("md")]: {
        minHeight: "400px"
      }
    },
    bigAvatar: {
      backgroundColor: theme.palette.primary.main,
      padding: "2rem",
      width: "6rem",
      height: "6rem",
      marginBottom: "2rem"
    },
    onBoardingIcon: {
      fontSize: "4rem !important"
    },
    onBoardingTitle: {
      marginTop: "1rem",
      marginBottom: "2rem"
    },
    onBoardingButton: {
      marginTop: "3rem",
      marginBottom: "2rem",
      width: 200
    },
    stepActiveColor: {
      backgroundColor: `${theme.palette.primary.main}`
    },
    stepDoneColor: {
      backgroundColor: `${theme.palette.success.dark}`
    },
    finishedAvatar: {
      backgroundColor: theme.palette.success.dark,
      padding: "2rem",
      width: "6rem",
      height: "6rem",
      marginBottom: "2rem"
    },
    gridField: {
      width: "100%"
    },
    field: {
      display: "flex",
      justifyContent: "center",
      marginBottom: theme.spacing(2)
    },
    fieldInline: {
      display: "flex",
      marginBottom: theme.spacing(2),
      [theme.breakpoints.up("md")]: {
        display: "inline-flex",
        marginRight: theme.spacing(2),
        width: "45%"
      }
    },
    downloadButtons: {
      display: "flex",
      justifyContent: "center",
      alignContent: "center",
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    },
    fileUploadArea: {
      width: "100%",
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    },
    dropZone: {
      minHeight: "0px !important"
    },
    dropzoneTextClass: {
      fontSize: "1.2rem"
    }
  })
);
